var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadexclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.57803 0 0 3.57834 0 8C0 12.422 3.57834 16 8 16C12.422 16 16 12.4217 16 8C16 3.57803 12.4217 0 8 0ZM8 14.75C4.26897 14.75 1.25 11.7308 1.25 8C1.25 4.26897 4.26922 1.25 8 1.25C11.731 1.25 14.75 4.26922 14.75 8C14.75 11.731 11.7308 14.75 8 14.75Z",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 4.0274C7.65481 4.0274 7.375 4.30722 7.375 4.6524V8.67719C7.375 9.02237 7.65481 9.30219 8 9.30219C8.34519 9.30219 8.625 9.02237 8.625 8.67719V4.6524C8.625 4.30722 8.34519 4.0274 8 4.0274Z",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.755C8.46599 11.755 8.84375 11.3772 8.84375 10.9113C8.84375 10.4453 8.46599 10.0675 8 10.0675C7.53401 10.0675 7.15625 10.4453 7.15625 10.9113C7.15625 11.3772 7.53401 11.755 8 11.755Z",
    fill: "#F26F21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadexclamation);
export default __webpack_public_path__ + "static/media/Upload exclamation.f6a1f41d516f370a57d114bebf4e4b02.svg";
export { ForwardRef as ReactComponent };